module.exports = __webpack_public_path__ + "img/product_119.a8fd398.webp";